<div class="relative">
<div class="flex items-center justify-between mt-8 gap-3 px-10">
  <div
    class="w-[40px] h-[40px] bg-[#285CA5] rounded-full flex items-center justify-center cursor-pointer"
    (click)="navigateTo(1)"
    title="Back"
  >
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.58893 1.16156C7.91437 1.487 7.91437 2.01463 7.58893 2.34007L3.17819 6.75081H12.833C13.2932 6.75081 13.6663 7.12391 13.6663 7.58415C13.6663 8.04438 13.2932 8.41748 12.833 8.41748H3.17819L7.58893 12.8282C7.91437 13.1537 7.91437 13.6813 7.58893 14.0067C7.26349 14.3322 6.73586 14.3322 6.41042 14.0067L0.577085 8.1734C0.251649 7.84797 0.251649 7.32033 0.577085 6.99489L6.41042 1.16156C6.73586 0.836121 7.26349 0.836121 7.58893 1.16156Z"
        fill="white"
      />
    </svg>
  </div>
  <div class="flex items-center gap-3">
    <button appearance="primary" tuiButton type="submit" size="s" (click)="printInvoice()">
      Print Invoice
    </button>
  </div>
</div>

<div *ngIf="isLoading" class="h-[400px] flex items-center justify-center">
    <tui-loader />
</div>

<section class="mx-5 lg:mx-0" id="printJS-form" *ngIf="!isLoading && record">
    <div class="flex flex-col mt-10 lg:mt-10 xl:mt-16 lg:mx-10 xl:mx-16">
                <div class="flex justify-between items-start">
            <div class="w-[268px] h-[84px]">
                <img src="/assets/logo-vertical.png" class="w-full h-full object-contain" alt="Royal Hospital Logo" />
            </div>
            <div class="flex flex-col items-center justify-center">
                <p class="font-semibold text-[2.25rem] text-[#00AEEF] py-1 m-0 text-center">
                    ROYAL HOSPITAL
                </p>
                <p class="font-semibold text-2xl text-[#EC008C] py-2 m-0 p-0 text-center">
                    HOME NURSING CARE
                </p>
                <p class="font-normal text-base text-[#212429] py-2 m-0 text-center">
                    No. 62, W.A.Silva Mawatha, Wellawatta, Colombo - 06<br />
                    Hot Line: 0713257499(WhatsApp), 0760656778, 0114000100
                </p>
            </div>
            <div class="w-[268px] h-[84px] md:hidden lg:hidden xl:block 2xl:block"></div>
        </div>
        <div class="w-full bg-[#D9D9D9] h-[1px] mt-8 mb-3"></div>
        <div class="flex justify-between">
            <div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Invoice Number</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ invoiceNumber }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Record Ref No.</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.chargeRefNo }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Patient Name</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.clientName || 'N/A' }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Address</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.clientAddress || 'N/A' }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Contact No</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.clientContact || 'N/A' }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Nurse</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.nurseName || 'N/A' }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Doctor</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.doctorName || 'N/A' }}</p>
                </div>
            </div>

            <div class="ml-8">
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Date</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left">{{ record?.date | date: 'MM/dd/yyyy' }}</p>
                </div>
                <div class="flex items-start">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px] w-[9.5rem]">Procedure</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px] text-left break-words max-w-[15rem]">{{ record?.procedure || 'N/A' }}</p>
                </div>
            </div>

        </div>
        <div class="w-full bg-[#D9D9D9] h-[1px] my-3"></div>
        <div class="mt-8 flex justify-center">
            <div class="w-full max-w-[50rem]">
                <table tuiTable size="m" class="w-full">
                    <colgroup>
                        <col style="width:70%;">
                        <col style="width:30%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th tuiTh style="background-color: #F9FBFF; padding:8px 12px; text-align:left;">Payment Details</th>
                            <th tuiTh style="background-color: #F9FBFF; padding:8px 12px; text-align:right;">Amount</th>
                        </tr>
                    </thead>

                    <tbody tuiTbody>
                        <tr *ngFor="let item of getPaymentItems()">
                            <td tuiTd style="padding:6px 12px;">
                                <span class="text-[#526ED3] text-sm">{{ item.description }}</span>
                            </td>
                           
                            <!-- total -->
                            <td tuiTd style="padding:6px 12px; text-align:right; white-space:nowrap;">
                                <span class="text-[#191C30E5] text-sm">LKR {{ item.quantity * item.unitPrice | number:'1.2-2' }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="w-full" style="display:grid; grid-template-columns:70% 30%;">
                    <div></div>
                    <div class="flex items-center justify-end mt-3 space-x-5">
                        <p class="font-bold text-sm text-[#000000A6]">Total</p>
                        <p class="text-[#285CA5] font-bold text-xl">LKR {{record?.grandTotal | number:'1.2-2'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full bg-[#D9D9D9] h-[1px] my-8"></div>
        <div class="flex space-x-28">
            <div>
                <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Account Details</p>
            </div>
            <div>
                <p class="text-base font-medium text-[#353A3F] my-[5px] ">Royal Hospital Home Nursing (pvt) ltd <br>
                    Commercial Bank 1000650035 <br>
                    Wellawatta 02nd Branch <br>
                    Swift Code CCEYLKLX</p>
            </div>
        </div>
    </div>
</section>
</div>
